import { StoreDeviceType } from 'src/graphql/generated/graphql';

export const getActionSupportedDeviceTypes = (action: {
  appliesToBOS: boolean;
  appliesToEPR: boolean;
  appliesToPOS: boolean;
  appliesToKVS: boolean;
  appliesToRHS: boolean;
  appliesToWST: boolean;
}) => {
  const typesSet = new Set<string>();
  if (action.appliesToBOS) {
    typesSet.add(StoreDeviceType.Bos);
  }
  if (action.appliesToEPR) {
    typesSet.add(StoreDeviceType.Epr);
  }
  if (action.appliesToPOS) {
    typesSet.add(StoreDeviceType.Pos);
  }
  if (action.appliesToKVS) {
    typesSet.add(StoreDeviceType.Kvs);
  }
  if (action.appliesToRHS) {
    typesSet.add(StoreDeviceType.Rhs);
  }
  if (action.appliesToWST) {
    typesSet.add(StoreDeviceType.Wst);
  }

  return Array.from(typesSet);
};
